<template>
  <div class="horizontal-line">
    <svg xmlns="http://www.w3.org/2000/svg" width="350" height="2" viewBox="0 0 350 2" fill="none">
      <path d="M-16 1H336" stroke="#001B2D" stroke-opacity="0.05" stroke-linecap="round" />
    </svg>
  </div>
</template>

<script setup lang="ts"></script>

<style scoped lang="scss">
.horizontal-line {
  position: relative;
  left: -32px;
  top: -0.5px;
}
</style>
